import { render, staticRenderFns } from "./showTypeForm.vue?vue&type=template&id=0690a852&"
import script from "./showTypeForm.vue?vue&type=script&lang=js&"
export * from "./showTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports